<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectSeparator, type SelectSeparatorProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectSeparatorProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectSeparatorProps>;
</script>

<template>
  <SelectSeparator v-bind="forwarded" />
</template>
